import React from 'react';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { intlShape, injectIntl } from 'react-intl';

import * as actions from '../../../actions/session.actions';
import { BlueRightArrowIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: undefined,
            step: 0
        }
    }

    /*
    static getDerivedStateFromProps(props, state) {
        const { onboarding } = props;
        if (onboarding !== state.info) {
            return state;
        }
        return null;
    }
    */

    getSteps = () => {
        const { intl } = this.props;
        if(isMobile) {
            return [
                {
                    id: 1,
                    img: '/img/mobile7.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_1' })
                },
                {
                    id: 2,
                    img: '/img/mobile2.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_2' })
                },
                {
                    id: 3,
                    img: '/img/mobile2b.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_3' })
                },
                {
                    id: 4,
                    img: '/img/mobile2c.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_4' })
                },
                {
                    id: 5,
                    img: '/img/mobile2d.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_5' })
                },
                {
                    id: 6,
                    img: '/img/mobile2e.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_6' })
                },
                {
                    id: 7,
                    img: '/img/mobile2e2.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_7' })
                },
                {
                    id: 8,
                    img: '/img/mobile2e3.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_8' })
                },
                {
                    id: 9,
                    img: '/img/mobile2f.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_9' })
                },
                {
                    id: 10,
                    img: '/img/mobile3.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_10' })
                },
                {
                    id: 11,
                    img: '/img/mobile4.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_11' })
                },
                {
                    id: 12,
                    img: '/img/mobile7.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_14' })
                },
                {
                    id: 13,
                    img: '/img/mobile7.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_13' })
                }
            ]
        } else {
            return [
                {
                    id: 1,
                    img: '/img/step7.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_1' })
                },
                {
                    id: 2,
                    img: '/img/step2.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_2' })
                },
                {
                    id: 3,
                    img: '/img/step2b.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_3' })
                },
                {
                    id: 4,
                    img: '/img/step2c.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_4' })
                },
                {
                    id: 5,
                    img: '/img/step2d.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_5' })
                },
                {
                    id: 6,
                    img: '/img/step2e.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_6' })
                },
                {
                    id: 7,
                    img: '/img/step2e2.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_7' })
                },
                {
                    id: 8,
                    img: '/img/step2e3.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_8' })
                },
                {
                    id: 9,
                    img: '/img/step2f.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_9' })
                },
                {
                    id: 10,
                    img: '/img/step3.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_10' })
                },
                {
                    id: 11,
                    img: '/img/step4.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_11' })
                },
                {
                    id: 12,
                    img: '/img/step5.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_12' })
                },
                {
                    id: 13,
                    img: '/img/step7.png',
                    label: intl.formatMessage({ id: 'tutorial_welcome_13' })
                }
            ]
        }
    }

    handleNext = (event) => {
        if(this.state.step + 1 === this.getSteps().length ) {
            this.props.setTutorial(false)
        }
        this.setState({ step: this.state.step + 1 })
    }

    render() {
        const { step } = this.state;
        const steps = this.getSteps();
        const current = step < steps.length ? steps[step]  : undefined

        console.log(isMobile);
        return (
            <div className="bodytutorial">
                {current &&
                    <div className="flex_auto_row align_center" onClick={this.handleNext}>
                        <img src={current.img} alt={`step${current.id}`} className="timg" />
                        <BlueRightArrowIcon className="next" />
                    </div>
                }
                {current &&
                    <div className="margin_top_24 barlowcondensed_medium borderRadius padding_borders c_white bg_bluish"
                        dangerouslySetInnerHTML={{ __html: current.label }} >
                    </div>
                }
            </div>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired
};

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)));



// WEBPACK FOOTER //
// ./src/components/complex/tutorial/index.js